import React from 'react';
import { render } from 'react-dom';

import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';

import App from './containers/App';

import Page404 from 'routes/404/components/404'

import { store, history } from './stores/configureStore';
import {
  SET_USER_ROLE,
  AUTHENTICATE_USER,
  SET_USER_DETAILS
} from './constants/ActionTypes';

//services
import LocalStorageService from './services/LocalStorageService'; var ls = LocalStorageService;

if (ls.getUserDetails() && ls.getUserDetails().roles && ls.getUserDetails().roles.length) {
  store.dispatch({ type: SET_USER_ROLE, role: ls.getUserDetails().roles[0] });
  if (ls.getToken()) {
    store.dispatch({ type: AUTHENTICATE_USER, auth: true });
    if (ls.getUserDetails()) {
      store.dispatch({ type: SET_USER_DETAILS, user: ls.getUserDetails() });
    }
  }
}
else {
  store.dispatch({ type: AUTHENTICATE_USER, auth: false });
  store.dispatch({ type: SET_USER_DETAILS, user: {} });
}


render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/" component={App} />
        <Route component={Page404} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('app-container')
);



// WEBPACK FOOTER //
// ./client.js